

























































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

// 添加类型声明
declare module 'vue/types/vue' {
  interface Vue {
    scope: any;
  }
}

@Component({
  components: {}
})
export default class ArticleCatalogPopup extends Vue {

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Prop() private coverId!: String; // uuid

  @Watch('coverId', { immediate: true, deep: true })
  public onChangeCoverId(newVal: any, oldVal: any) {
    console.log('coverId watch', newVal)
    const isEdit = !!newVal;
    this.isEdit = isEdit;
    
    // 重置所有状态数据
    this.folderList = [];
    this.coverOptions = [];
    this.foldersWithArticles = new Map();
    this.checkedFolders = new Set();
    this.refreshKey = 0;
    this.isInitializingData = false;
    
    if (isEdit) {
      this.fetchFolderDetail();
    } else {
      // 新增模式：重置基础表单为初始状态
      this.baseForm = {
        appCoverId: '', // 封面ID
        appCoverName: '', // 封面名称
        modelCode: '', // 模块代码
        openScope: '', // 开放范围
        userGroups: [], // 用户组
        description: '', // 说明
        userNames:''
      };
      this.fetchCoverOptions();
    }
  }

  public isEdit: boolean = false;

  // 基础表单
  public baseForm: any = {
    appCoverId: '', // 封面ID
    appCoverName: '', // 封面名称
    modelCode: '', // 模块代码
    openScope: '', // 开放范围
    userGroups: [], // 用户组
    description: '', // 说明
    userNames:''
  };

  // 目录列表
  public folderList: any[] = [];

  // 封面选项
  public coverOptions: any[] = [];

  // 强制刷新键，用于重新渲染组件
  public refreshKey: number = 0;

  // 存储已关联文章的目录ID
  public foldersWithArticles: Map<string, boolean> = new Map();
  // 存储已检查过的目录ID
  public checkedFolders: Set<string> = new Set();
  
  // 初始化数据标志，用于避免在数据加载时显示提示
  public isInitializingData: boolean = false;

  // 模块类型名称
  public get moduleTypeName(): string {
    const dict = {
      'application': '应用',
      'scenarios': '业务场景',
      'novartis_video': '诺华视界',
    }
    return dict[this.baseForm.modelCode] || '';
  }

  // 开放范围展示
  public get openScopeDisplay(): string {
    if (!this.baseForm.openScope) return '';
    return Array.isArray(this.baseForm.openScope) ? this.baseForm.openScope.join(', ') : this.baseForm.openScope;
  }

  // 用户组展示
  public get userGroupsDisplay(): string {
    if (!this.baseForm.userGroups || !Array.isArray(this.baseForm.userGroups)) return '';
    return this.baseForm.userGroups.map((item: any) => item.groupName).join(', ');
  }

  public async created(): Promise<void> {
  }

  // 检查目录是否有关联文章
  private async checkFolderHasArticle(folderId: string): Promise<boolean> {
    try {
      // 如果没有ID或是新增目录，不需要检查
      if (!folderId) return false;

      // 如果已经检查过，直接返回缓存结果
      if (this.checkedFolders.has(folderId)) {
        return this.foldersWithArticles.get(folderId) || false;
      }

      // 调用API检查是否有关联文章
      const res = await this.nuoxiaoerService.fetchFolderRelationArticle({
        appCoverId: this.baseForm.appCoverId,
        id: folderId
      });

      // 记录检查结果
      this.checkedFolders.add(folderId);
      this.foldersWithArticles.set(folderId, res === true);

      return res === true;
    } catch (error) {
      console.error('检查目录关联文章失败：', error);
      return false;
    }
  }

  // 获取封面选项
  private async fetchCoverOptions(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.fetchFilteredCoverOption();
      console.log('封面列表',res)
      if (res) {
        this.coverOptions = res.map((item: any) => ({
          id: item.id,
          name: item.name,
          modelCode: item.modelCode,
          openScope: item.openScope,
          userGroups: item.userGroups,
          userNames: item.userNames ? item.userNames.join(",") : '',
        }));
      }
    } catch (error) {
      console.error('获取封面列表失败：', error);
      this.$message.error('获取封面列表数据失败，请稍后重试');
    }
  }

  // 获取目录详情
  private async fetchFolderDetail(): Promise<void> {
    try {
      // 设置初始化标志，避免在数据加载时显示提示
      this.isInitializingData = true;
      
      const res = await this.nuoxiaoerService.fetchFolderDetail({ appCoverId: this.coverId });
      if (res) {
        // 设置基础信息
        this.baseForm = {
          appCoverId: res.appCoverId,
          appCoverName: res.appCoverName,
          modelCode: res.modelCode,
          openScope: res.openScope,
          userGroups: res.userGroups,
          description: res.description,
          userNames:res.userNames?res.userNames.join(','):''
        };

        // 设置目录列表
        this.folderList = res.folderManagerVOS || [];

        // 处理每个目录的上级目录和关键字
        this.folderList.forEach(folder => {
          // 确保所有需要的属性都存在
          Vue.set(folder, 'keyWord', '');
          Vue.set(folder, 'keyWordOrder', 1);

          if (folder.parentFolderName) {
            // 查找父目录ID
            const parentFolder = this.folderList.find(f => f.name === folder.parentFolderName);
            if (parentFolder) {
              folder.parentFolderId = parentFolder.id;
            }
          } else {
            folder.parentFolderId = '';
          }

          // 处理关键字
          if (folder.keyWordVO && folder.keyWordVO.name) {
            folder.keyWord = folder.keyWordVO.name;
            folder.keyWordOrder = folder.keyWordVO.sortNumber || 1;
          }
        });

        // 确保Vue跟踪整个列表的变化
        this.folderList = [...this.folderList];
      }
    } catch (error) {
      console.error('获取目录详情失败：', error);
      this.$message.error('获取目录详情失败，请刷新重试');
    } finally {
      // 数据初始化完成，重置标志
      this.isInitializingData = false;
    }
  }

  // 封面变更事件
  public async coverChanged(value: string): Promise<void> {
    const selectedCover = this.coverOptions.find(item => item.id === value);
    console.log('selectedCover',selectedCover);
    if (selectedCover) {
      this.baseForm.modelCode = selectedCover.modelCode;
      this.baseForm.openScope = selectedCover.openScope;
      this.baseForm.userGroups = selectedCover.userGroups;
      this.baseForm.appCoverName = selectedCover.name;
      this.baseForm.userNames = selectedCover.userNames; // 确保用户信息也被设置

      // 清空目录列表
      this.folderList = [];
    }
  }

  // 添加目录
  public addFolder(): void {
    // 生成临时ID，用于新增目录的标识
    const tempId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    
    const newFolder = {
      id: tempId, // 使用临时ID，保存时会被服务器分配真实ID
      modelCode: this.baseForm.modelCode,
      appCoverId: this.baseForm.appCoverId,
      name: '',
      keyWord: '',
      keyWordOrder: 1,
      parentFolderId: '',
      folderLevel: 1,
      sortNumber: this.folderList.length + 1, // 设置为下一个顺序号
      createdTime: null,
      updatedTime: null,
      isNew: true // 标记为新增目录
    };

    this.folderList.push(newFolder);
    
    // 强制更新refreshKey以触发所有下拉选择器重新渲染
    this.refreshKey++;
  }

  // 删除目录
  public async removeFolder(index: number): Promise<void> {
    const folder = this.folderList[index];

    // 检查是否有子目录依赖
    if (this.hasDependentFolders(folder.id)) {
      this.$message.error('该目录已被其他目录设为上级目录，无法删除');
      return;
    }

    // 如果目录有ID且不是新增目录，检查是否有关联文章
    if (folder.id && !folder.isNew && !folder.id.toString().startsWith('temp_')) {
      const loading = this.$loading({
        lock: true,
        text: '正在检查目录关联状态...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const hasArticles = await this.checkFolderHasArticle(folder.id);
        loading.close();

        if (hasArticles) {
          this.$message.error('该目录已关联文章，无法删除');
          return;
        }
      } catch (error) {
        loading.close();
        console.error('检查目录关联文章失败：', error);
        this.$message.error('检查目录状态失败，请稍后重试');
        return;
      }
    }

    // 不管是新增目录还是已存在目录，都需要二次确认
    try {
      await this.$confirm('请确认是否删除此目录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      this.folderList.splice(index, 1);
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }

  // 判断是否有依赖该目录的子目录
  public hasDependentFolders(id: string | number): boolean {
    if (!id) return false;
    return this.folderList.some(folder => folder.parentFolderId === id);
  }

  // 获取可用作父目录的选项
  public getAvailableParentFolders(currentId: string | number): any[] {
    // 排除当前目录自身和已经将当前目录作为父级的目录（防止循环引用）
    const unavailableFolders = new Set<string | number>();

    // 添加当前目录到不可用列表
    if (currentId) unavailableFolders.add(currentId);

    // 查找以当前目录为父级的所有子目录（直接或间接）
    const findChildFolders = (id: string | number) => {
      const children = this.folderList.filter(f => f.parentFolderId === id);
      children.forEach(child => {
        unavailableFolders.add(child.id);
        if (child.id) findChildFolders(child.id);
      });
    };

    if (currentId) findChildFolders(currentId);

    // 返回可用的目录选项
    return this.folderList.filter(folder =>
      folder.id &&
      folder.name && // 只有有名称的目录才能作为父目录选项
      folder.name.trim() !== '' && // 确保名称不是空字符串或只有空格
      !unavailableFolders.has(folder.id) &&
      // 限制目录层级不超过5层
      folder.folderLevel < 5
    );
  }

  // 当选择上级目录时，更新当前目录的层级
  public handleParentChange(parentId: string | number, index: number): void {
    console.log('handleParentChange', parentId, index);
    const currentFolder = this.folderList[index];
    const oldParentId = currentFolder.parentFolderId;
    const currentId = currentFolder.id;
    
    // 如果新旧父级相同，无需处理
    if (parentId === oldParentId) return;
    
    // 直接修改属性值
    currentFolder.parentFolderId = parentId;
    
    // 获取当前目录的所有子目录（直接和间接）
    const childFolders = this.getAllChildFolders(currentId);
    
    if (!parentId) {
      // 没有父级目录，层级为1
      currentFolder.folderLevel = 1;
      
      // 更新所有子目录的层级
      this.updateChildFoldersLevel(childFolders, currentFolder);
    } else {
      // 有父级目录，层级为父级+1
      const parentFolder = this.folderList.find(f => f.id === parentId);
      if (parentFolder) {
        // 检查是否会造成循环引用
        if (this.wouldCreateCycle(currentId, parentId)) {
          this.$message.error('无法设置该上级目录，会造成循环引用');
          // 恢复原来的父级
          currentFolder.parentFolderId = oldParentId;
          // 增加refreshKey强制重新渲染
          this.refreshKey++;
          return;
        }
        
        currentFolder.folderLevel = parentFolder.folderLevel + 1;
        
        // 更新所有子目录的层级
        this.updateChildFoldersLevel(childFolders, currentFolder);
        
        // 同步最父级节点的关键字到当前节点及其所有子节点
        this.syncWithRootParentDirectly(currentFolder, childFolders);
      }
    }
    
    // 增加refreshKey强制重新渲染el-select组件
    this.refreshKey++;
    
    // 强制Vue更新视图
    this.$forceUpdate();
  }

  // 获取目录的所有子目录（包括直接和间接子目录）
  private getAllChildFolders(folderId: string | number): any[] {
    if (!folderId) return [];
    
    const result: any[] = [];
    
    const findChildren = (id: string | number) => {
      const children = this.folderList.filter(f => f.parentFolderId === id);
      children.forEach(child => {
        result.push(child);
        if (child.id) findChildren(child.id);
      });
    };
    
    findChildren(folderId);
    return result;
  }

  // 更新子目录的层级
  private updateChildFoldersLevel(childFolders: any[], parentFolder: any): void {
    if (!childFolders || !childFolders.length) return;
    
    const updateLevel = (folder: any, level: number) => {
      folder.folderLevel = level;
      
      // 更新直接子目录
      const directChildren = childFolders.filter(f => f.parentFolderId === folder.id);
      directChildren.forEach(child => updateLevel(child, level + 1));
    };
    
    // 更新所有直接子目录
    const directChildren = childFolders.filter(f => f.parentFolderId === parentFolder.id);
    directChildren.forEach(child => updateLevel(child, parentFolder.folderLevel + 1));
  }

  // 检查是否会造成循环引用
  private wouldCreateCycle(currentId: string | number, newParentId: string | number): boolean {
    if (!currentId || !newParentId) return false;
    
    // 检查新的父级是否是当前节点的子节点
    const isDescendant = (parentId: string | number, childId: string | number): boolean => {
      if (parentId === childId) return true;
      
      const children = this.folderList.filter(f => f.parentFolderId === parentId);
      return children.some(child => isDescendant(child.id, childId));
    };
    
    return isDescendant(currentId, newParentId);
  }

  // 提交表单
  public async submitForm(): Promise<void> {
    // 验证表单
    if (!this.validateForm()) {
      return;
    }

    try {
      // 确认保存
      await this.$confirm('是否确认保存并发布？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info'
      });

      // 构建提交数据
      const submitData: any = {
        modelCode: this.baseForm.modelCode,
        appCoverId: this.baseForm.appCoverId,
        appCoverName: this.baseForm.appCoverName,
        openScope: this.baseForm.openScope,
        userGroups: this.baseForm.userGroups,
        description: this.baseForm.description,
        userNames:this.baseForm.userNames,
        folderManagerVOS: this.folderList.map(folder => {
          const folderData = {
            // 如果是新增目录（临时ID），则不传ID，让服务器分配
            id: (folder.isNew || folder.id.toString().startsWith('temp_')) ? null : folder.id,
            modelCode: this.baseForm.modelCode,
            appCoverId: this.baseForm.appCoverId,
            name: folder.name,
            keyWordVO: folder.keyWord ? {
              name: folder.keyWord,
              sortNumber: folder.keyWordOrder || 1
            } : null,
            folderLevel: folder.folderLevel,
            parentFolderName: this.getParentFolderName(folder.parentFolderId),
            sortNumber: folder.sortNumber,
            createdTime: folder.createdTime,
            updatedTime: folder.updatedTime
          };
          return folderData;
        })
      };

      console.log('提交数据:', submitData);

      // 保存数据
      await this.nuoxiaoerService.saveFolder(submitData);

      this.$message({ message: '保存成功', type: 'success' });

      this.emitSaved();
    } catch (error) {
      if (error === 'cancel') {
        // 用户取消操作，不做处理
        return;
      }
      console.error('保存失败：', error);
      this.$message.error('保存失败：' + (error.message || '未知错误'));
    }
  }

  // 获取父目录名称
  private getParentFolderName(parentId: string | number): string {
    if (!parentId) return null;
    const parentFolder = this.folderList.find(f => f.id === parentId);
    return parentFolder ? parentFolder.name : null;
  }

  // 验证表单
  private validateForm(): boolean {
    // 验证基础信息
    if (!this.baseForm.appCoverId) {
      this.$message.error('请选择所属封面');
      return false;
    }

    // 验证目录列表
    // if (this.folderList.length === 0) {
    //   this.$message.error('请至少添加一个目录');
    //   return false;
    // }

    // 验证每个目录的必填项
    for (let i = 0; i < this.folderList.length; i++) {
      const folder = this.folderList[i];

      if (!folder.name) {
        this.$message.error(`第${i+1}行目录名称不能为空`);
        return false;
      }

      // 检查目录名称重复
      if (this.isDuplicateName(folder.name, i)) {
        this.$message.error(`第${i+1}行目录名称"${folder.name}"与其他目录重复，请修改`);
        return false;
      }

      if (!folder.sortNumber) {
        this.$message.error(`第${i+1}行目录顺序不能为空`);
        return false;
      }

      if (folder.keyWord && !folder.keyWordOrder) {
        this.$message.error(`第${i+1}行已填写关键字，关键字顺序不能为空`);
        return false;
      }
    }

    // 验证目录名称全局唯一性
    const nameSet = new Set();
    for (let i = 0; i < this.folderList.length; i++) {
      const name = this.folderList[i].name;
      if (name) {
        if (nameSet.has(name)) {
          this.$message.error(`目录名称"${name}"重复，请确保所有目录名称唯一`);
          return false;
        }
        nameSet.add(name);
      }
    }

    // 验证关键字一致性
    if (!this.validateKeywordConsistency()) {
      return false;
    }

    return true;
  }

  // 验证关键字一致性
  private validateKeywordConsistency(): boolean {
    // 按分支验证关键字一致性
    const branchRoots = this.folderList.filter(f => !f.parentFolderId);
    
    for (const root of branchRoots) {
      if (!this.validateBranchKeywordConsistency(root)) {
        return false;
      }
    }
    
    return true;
  }

  // 验证单个分支的关键字一致性
  private validateBranchKeywordConsistency(rootFolder: any): boolean {
    // 获取该分支的所有目录
    const branchFolders = this.getBranchFolders(rootFolder.id);
    
    // 如果根目录有关键字，检查所有子目录是否一致
    if (rootFolder.keyWord) {
      for (const folder of branchFolders) {
        if (folder.keyWord && folder.keyWord !== rootFolder.keyWord) {
          this.$message.error(`目录"${folder.name}"的关键字"${folder.keyWord}"与分支根目录"${rootFolder.name}"的关键字"${rootFolder.keyWord}"不一致，请保持一致`);
          return false;
        }
        
        if (folder.keyWord === rootFolder.keyWord && folder.keyWordOrder !== rootFolder.keyWordOrder) {
          this.$message.error(`目录"${folder.name}"的关键字顺序"${folder.keyWordOrder}"与分支根目录"${rootFolder.name}"的关键字顺序"${rootFolder.keyWordOrder}"不一致，请保持一致`);
          return false;
        }
      }
    }
    
    // 检查同级目录关键字一致性
    const levelGroups = new Map<number, any[]>();
    [rootFolder, ...branchFolders].forEach(folder => {
      const level = folder.folderLevel;
      if (!levelGroups.has(level)) {
        levelGroups.set(level, []);
      }
      levelGroups.get(level)!.push(folder);
    });
    
    for (const [level, folders] of levelGroups) {
      // 检查同级目录中有关键字的目录是否一致
      const foldersWithKeyword = folders.filter(f => f.keyWord);
      if (foldersWithKeyword.length > 1) {
        const firstKeyword = foldersWithKeyword[0].keyWord;
        const firstKeywordOrder = foldersWithKeyword[0].keyWordOrder;
        
        for (let i = 1; i < foldersWithKeyword.length; i++) {
          const folder = foldersWithKeyword[i];
          if (folder.keyWord !== firstKeyword) {
            this.$message.error(`第${level}层级的目录"${folder.name}"与"${foldersWithKeyword[0].name}"的关键字不一致，同级目录的关键字必须保持一致`);
            return false;
          }
          
          if (folder.keyWordOrder !== firstKeywordOrder) {
            this.$message.error(`第${level}层级的目录"${folder.name}"与"${foldersWithKeyword[0].name}"的关键字顺序不一致，同级目录的关键字顺序必须保持一致`);
            return false;
          }
        }
      }
    }
    
    return true;
  }

  // 获取指定分支的所有子目录
  private getBranchFolders(rootId: string | number): any[] {
    const result: any[] = [];
    
    const findChildren = (parentId: string | number) => {
      const children = this.folderList.filter(f => f.parentFolderId === parentId);
      children.forEach(child => {
        result.push(child);
        if (child.id) findChildren(child.id);
      });
    };
    
    findChildren(rootId);
    return result;
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }

  // 直接与整个树的根节点（最父级）同步关键字，无需确认
  private syncWithRootParentDirectly(currentFolder: any, childFolders: any[]): void {
    // 如果当前节点没有父节点，它自己就是根节点，不需要同步
    if (!currentFolder.parentFolderId) return;
    
    // 查找当前节点所在树的根节点
    let rootParent = this.findRootParent(currentFolder);
    
    // 如果找到根节点
    if (rootParent) {
      // 同步当前目录的关键字和关键字顺序（无论根节点关键字是否为空）
      currentFolder.keyWord = rootParent.keyWord || '';
      currentFolder.keyWordOrder = rootParent.keyWordOrder || 1;
      
      // 同步当前目录的所有子目录
      childFolders.forEach(child => {
        child.keyWord = rootParent.keyWord || '';
        child.keyWordOrder = rootParent.keyWordOrder || 1;
      });
      
      // 如果根节点关键字为空，确保所有相关节点的关键字都被清空
      if (!rootParent.keyWord) {
        currentFolder.keyWord = '';
        currentFolder.keyWordOrder = 1;
        
        childFolders.forEach(child => {
          child.keyWord = '';
          child.keyWordOrder = 1;
        });
      }
    }
  }

  // 查找节点所在树的根节点（最顶层的父节点）
  private findRootParent(folder: any): any {
    if (!folder || !folder.parentFolderId) return folder; // 如果没有父级，自己就是根节点
    
    let currentFolder = folder;
    let rootParent = null;
    
    // 沿着父级路径向上查找，直到找到没有父级的节点
    while (currentFolder.parentFolderId) {
      const parent = this.folderList.find(f => f.id === currentFolder.parentFolderId);
      if (!parent) break; // 如果找不到父级，结束循环
      
      rootParent = parent;
      currentFolder = parent;
      
      // 如果形成循环引用，终止查找
      if (currentFolder.parentFolderId === folder.id) {
        console.error('检测到循环引用', folder.id);
        break;
      }
    }
    
    return rootParent || folder;
  }

  // 处理关键字变更
  public handleChangeKeyword(idx: number, val: string): void {
    console.log('keyword change:', idx, val);
    const currentFolder = this.folderList[idx];
    
    // 获取当前目录的所有子目录
    const childFolders = this.getAllChildFolders(currentFolder.id);
    
    if (!val) {
      // 关键字为空时，重置关键字顺序并清空所有子目录的关键字
      currentFolder.keyWordOrder = 1;
      
      if (childFolders.length > 0) {
        // 直接清空所有子目录的关键字，不需要二次确认
        childFolders.forEach(child => {
          child.keyWord = '';
          child.keyWordOrder = 1;
        });
        
        // 刷新UI
        this.folderList = [...this.folderList];
        
        // 只有在非初始化状态时才显示提示
        if (!this.isInitializingData) {
          this.$message.success(`已自动清空所有子目录的关键字`);
        }
      }
      return;
    }
    
    if (childFolders.length > 0) {
      // 直接同步到所有子目录，不需要二次确认
      childFolders.forEach(child => {
        child.keyWord = val;
        child.keyWordOrder = currentFolder.keyWordOrder || 1;
      });
      
      // 刷新UI
      this.folderList = [...this.folderList];
      
      // 只有在非初始化状态时才显示提示
      if (!this.isInitializingData) {
        this.$message.success(`已自动将关键字"${val}"同步到所有子目录`);
      }
    }
  }

  // 处理关键字顺序输入
  public handleKeywordOrderInput(idx: number, val: number): void {
    console.log('keyword order change:', idx, val);
    const currentFolder = this.folderList[idx];
    
    // 如果没有关键字，不允许设置顺序
    if (!currentFolder.keyWord) {
      currentFolder.keyWordOrder = 1;
      return;
    }
    
    // 检查是否有父级目录
    if (currentFolder.parentFolderId) {
      // 子目录的关键字顺序由最父级目录统一管理，不允许单独修改
      const rootParent = this.findRootParentOfBranch(currentFolder);
      
      if (rootParent && rootParent.keyWord === currentFolder.keyWord && rootParent.keyWordOrder) {
        currentFolder.keyWordOrder = rootParent.keyWordOrder;
        return;
      }
    }
    
    // 如果是最父级目录，可以修改顺序，并同步到所有子目录
    if (!currentFolder.parentFolderId) {
      currentFolder.keyWordOrder = val;
      
      // 获取当前目录的所有子目录
      const childFolders = this.getAllChildFolders(currentFolder.id);
      
      if (childFolders.length > 0) {
        // 同步关键字顺序到所有有相同关键字的子目录
        childFolders.forEach(child => {
          if (child.keyWord === currentFolder.keyWord) {
            child.keyWordOrder = val;
          }
        });
        
        // 刷新UI
        this.folderList = [...this.folderList];
        
        // 只有在非初始化状态时才显示提示
        // if (!this.isInitializingData) {
        //   this.$message.success(`已自动将关键字顺序"${val}"同步到所有相同关键字的子目录`);
        // }
      }
    } else {
      // 其他情况（理论上不应该到达这里，因为子目录的顺序输入应该被禁用）
      currentFolder.keyWordOrder = val;
    }
  }

  // 判断关键字是否应该禁用
  public isKeywordDisabled(folder: any): boolean {
    // 所有有父级目录的都应该禁用关键字输入，不管父级是否有关键字
    if (folder.parentFolderId) {
      return true;
    }
    
    return false;
  }

  // 判断关键字顺序是否应该禁用
  public isKeywordOrderDisabled(folder: any): boolean {
    // 如果没有关键字，禁用顺序输入
    if (!folder.keyWord) {
      return true;
    }
    
    // 如果有父级目录
    if (folder.parentFolderId) {
      // 查找当前目录所在这一支的最父级目录
      const rootParent = this.findRootParentOfBranch(folder);
      
      // 如果这一支的最父级有相同关键字，子目录不能独立设置顺序
      if (rootParent && rootParent.keyWord === folder.keyWord && rootParent.keyWordOrder) {
        return true;
      }
    }
    
    return false;
  }

  // 查找节点所在分支的根节点（这一支的最顶层父节点）
  private findRootParentOfBranch(folder: any): any {
    if (!folder || !folder.parentFolderId) return null; // 如果没有父级，说明自己就是根节点
    
    let currentFolder = folder;
    let rootParent = null;
    
    // 沿着父级路径向上查找，直到找到没有父级的节点
    while (currentFolder.parentFolderId) {
      const parent = this.folderList.find(f => f.id === currentFolder.parentFolderId);
      if (!parent) break; // 如果找不到父级，结束循环
      
      rootParent = parent;
      currentFolder = parent;
      
      // 如果形成循环引用，终止查找
      if (currentFolder.parentFolderId === folder.id) {
        console.error('检测到循环引用', folder.id);
        break;
      }
    }
    
    return rootParent; // 返回这一支的最父级节点
  }

  // 目录名称重复性验证
  public validateFolderName(rule: any, value: string, callback: any, index: number): void {
    // 允许为空
    if (!value) {
      callback();
      return;
    }

    // 获取当前目录
    const currentFolder = this.folderList[index];

    // 检查其他目录是否有相同名称
    const isDuplicate = this.folderList.some((folder, idx) => 
      folder.name === value && 
      idx !== index // 排除当前编辑的目录
    );

    if (isDuplicate) {
      callback(new Error('目录名称已存在，请修改'));
    } else {
      callback();
    }
  }

  // 处理目录名称输入
  public handleFolderNameInput(index: number, value: string): void {
    const folder = this.folderList[index];
    
    // 实时更新目录名称
    folder.name = value;
    
    // 如果名称重复，立即显示提示
    if (this.isDuplicateName(value, index)) {
      this.$message.warning(`目录名称"${value}"已存在，请修改`);
    }
  }

  // 处理目录名称失去焦点
  public handleFolderNameBlur(index: number, value: string): void {
    // 触发表单验证
    this.$nextTick(() => {
      const folderForm = this.$refs.folderForm as any;
      if (folderForm) {
        folderForm.validateField(`folderList.${index}.name`);
      }
    });
  }

  // 检查目录名称是否重复
  public isDuplicateName(name: string, index: number): boolean {
    if (!name) return false;
    
    // 排除当前编辑的目录
    return this.folderList.some((folder, idx) => 
      folder.name && 
      folder.name.trim() === name.trim() && 
      idx !== index
    );
  }
}
